module.exports = __webpack_public_path__ + "static/media/sidebar-11.9b6effd7.jpg";